import { makeStyles } from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      gridTemplateAreas: `
        "profile"
        "personal"
        "password"
      !important`,
      gridTemplateColumns: '1fr !important'
    }
  },
  profile: {
    maxHeight: 0,
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100%'
    }
  },
  profileAvatar: {
    maxWidth: 180,
    maxHeight: 180,
    [theme.breakpoints.down('sm')]: {
      width: '150px !important',
      height: '150px !important'
    }
  }
}))
